import { isValidBCP47 } from '@reacture-io/iso-locale/languages';
import { z } from 'zod';

export const createTextTranslationWithTextSchema = z.object({
  input: z.string(),
  reference: z.string().optional(),
  sourceLanguageCode: z.custom<string>(isValidBCP47),
  targetLanguageCode: z.custom<string>(isValidBCP47),
  models: z.array(z.string()).min(1),
  temperature: z.array(z.number().min(0).max(1)).min(1),
  instructions: z.record(z.string(), z.string().optional()).optional(),
});

export type CreateTextTranslationWithTextSchema = z.infer<
  typeof createTextTranslationWithTextSchema
>;
